import * as React from "react";
import styles from "./templateName.module.less";
interface TemplateNameProps {
    name: string;
}
export function TemplateName({ name }: TemplateNameProps) {
    return (<div className={styles.name} title={name}>
            {name}
        </div>);
}
